<template>
  <el-table-column
    prop="type"
    label="Típus"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.type === 'inPacking' ? 'Becsomagolás' : 'Kicsomagolás' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'type',
  };
</script>
